// eslint-disable-next-line
// @ts-ignore
export const nonceTemplate = document.head.querySelector(
  'meta[property="csp-nonce"]'
)["nonce"];
